import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class CompoundingDepartmentService extends SingleDepartmentService {
  readonly NAME = 'Compounding';

  private _departmentId: number;

  get departmentId(): number {
    return this._departmentId;
  }

  set departmentId(value: number) {
    this._departmentId = value;
  }

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.includes('CompoundingAdmin') ||
      roles.includes('CompoundingChief') ||
      roles.includes('CompoundingLeader') ||
      roles.includes('CompoundingSupervisorScheduling') ||
      roles.includes('CompoundingChemist') ||
      roles.includes('CompoundingOperator')
    ) {
      this.router.navigate([`sb/compounding/scheduling/mixing-mill`]);
      return true;
    }
    if (
      roles.includes('CompoundingQc') ||
      roles.includes('CompoundingEngineer')
    ) {
      this.router.navigate([`sb/compounding/scheduling/extrusion`]);
      return true;
    }
    if (roles.includes('CompoundingLabel')) {
      this.router.navigate([`sb/compounding/packing-box`]);
      return true;
    }
    return false;
  }
}
